const galleryId = 17;

const items = [];

let id = galleryId * 1000;

function addItemToGroup(item, tag) {
    id++;
    items.push({
        "id": id,
        "title": { "en": "" },
        "src": item,
        "tags": [tag],
        "groups": [galleryId],
        "ordering": id,
    });
}
let group = [];

group = ["sh_1486975736.jpg","sh_1486975739.jpg","sh_1727881060.jpg","sh_1505970356.jpg","sh_1505970362.jpg","sh_1505970359.jpg"];
group.forEach((i) => addItemToGroup(i, '1. Mandibula / maxilla surgery'));

group = ["sh_1302070210.jpg","sh_1829640596.jpg","sh_1829640599.jpg"];
group.forEach((i) => addItemToGroup(i, 'Before-after'));

export default items;
